import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { CalendarState } from './types';
import { RootState } from '@/store/types';

export const state: CalendarState = {
    availableCalendars: [],
    calendars: [],
    events: [],
    eventFilters: {},
    calendarFilters: {},
};
const namespaced: boolean = true;

export const calendar: Module<CalendarState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
